import { render, staticRenderFns } from "./snapshot.vue?vue&type=template&id=28262938&scoped=true"
import script from "./snapshot.vue?vue&type=script&lang=js"
export * from "./snapshot.vue?vue&type=script&lang=js"
import style0 from "./snapshot.vue?vue&type=style&index=0&id=28262938&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28262938",
  null
  
)

export default component.exports